import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { BlueprintSummaryComponent } from './blueprint-summary.component';
import { TenantInstanceDetailsComponent } from './tenant-instance-details/tenant-instance-details.component';
import { ServiceDefinitionVersionComponent } from './service-definition-version/service-definition-version.component';
import { ResourceConfigurationComponent } from './resource-configuration/resource-configuration.component';
import { UpdateResourceConfigurationComponent } from './update-resource-configuration/update-resource-configuration.component';
import { EnvironmentDetailsComponent } from '../environment-details/environment-details.component';
import { CreateRunbook } from '../environment-details/environment-runbook/create-runbook/create-runbook';
import { CreateScheduleComponent } from '../environment-details/environment-schedule/create-schedule/create-schedule.component';
import { EnvironmentJobDetails } from '../environment-details/environment-jobs/environment-job-details/environment-job-details.component';
import { DeploySizingComponent } from './deploy-sizing/deploy-sizing.component';
import { UpdateServiceDefinitionCreation } from '../update-service-definition-creation/update-service-definition-creation.component';
import { UpdateServiceDefGuard } from '../update-service-definition-creation/update-service-def.guard';
const routes: Routes = [
  {
    path: '',
    component: BlueprintSummaryComponent,
  },{
    path: 'instance/:instanceId',
    component: TenantInstanceDetailsComponent
},{
    path: 'environment/:instanceId',
   component: EnvironmentDetailsComponent,
   title: 'Environment Details'
},
{
    path: 'environment/:instanceId/create-runbook',
   component: CreateRunbook,
   title: 'Create Runbook'
},
{
  path: 'environment/:instanceId/edit-runbook/:runbookId',
   component: CreateRunbook,
   title: 'Edit Runbook'
},
{
    path: 'environment/:instanceId/create-schedule',
   component: CreateScheduleComponent,
   title: 'Create Schedule'
},
{
  path: 'environment/:instanceId/edit-schedule/:scheduleId',
   component: CreateScheduleComponent,
   title: 'Edit Schedule'
},
{
  path: ':solutionId/extend',
  component: ServiceDefinitionVersionComponent,
},
{
  path: 'environment/:id/resource-config',
  component: ResourceConfigurationComponent,
},
{
  path: ':id/update-resource-config',
  component: UpdateResourceConfigurationComponent,
},
{
  path: ':instanceId/update-definition',
  component: UpdateServiceDefinitionCreation,
  title: 'Update Service Definition',
  canActivate: [UpdateServiceDefGuard]
},
{
   path: 'environment/:instanceId/job/:jobId',
   component: EnvironmentJobDetails,
   title: 'Job Details'
},
{
  path: 'environment/:id/deploy-sizing',
  component: DeploySizingComponent,
 }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BleuprintSummaryRoutingModule {
}
